import { flatten } from 'lodash'
import { routes as moduleRoutes } from '@/modules/register'

const routes = (() => {
  const requireRoutes = require.context('.', true, /^((?!index).)*\.js$/)

  return flatten([
    ...requireRoutes.keys().map(fileName => requireRoutes(fileName).default),
    ...moduleRoutes
  ])
})()

export default routes
